import { useRepository } from './auth'

export function useFeatureFlags() {
  return useRepository().featureFlags.flags
}
